export const environment = {
    production: false,
    preproduction: false,
    development: true,
    local: false,
    envName: 'dev',
    apiUrl: 'https://dev.samarplast.mes.devoltec.com/api/v1/',
    socketUrl: 'https://dev.samarplast.mes.devoltec.com/',
    socketPath: '/socket.io',
};
